import { StrictMode } from 'react'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
// eslint-disable-next-line import/no-unresolved
import { registerSW } from 'virtual:pwa-register'

import { router } from '@/app/routes'
import { queryClient } from '@/shared/lib'
import { enableMSW } from '@/shared/lib/msw'

import '@/shared/lib/clarity'
import '@/shared/lib/firebase'
import '@/shared/lib/i18n'

import './index.css'

registerSW({
  onRegisteredSW(_, serviceWorkerRegistration) {
    if (!serviceWorkerRegistration) return

    window.addEventListener('focus', () => {
      serviceWorkerRegistration.update()
    })

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        serviceWorkerRegistration.update()
      }
    })
  },
  immediate: true,
})

// NOSONAR
enableMSW().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </StrictMode>,
  )
})
